import { render, staticRenderFns } from "./CompanySettingsScimPage.vue?vue&type=template&id=9a28b2b0&scoped=true"
import script from "./CompanySettingsScimPage.vue?vue&type=script&lang=ts"
export * from "./CompanySettingsScimPage.vue?vue&type=script&lang=ts"
import style0 from "./CompanySettingsScimPage.vue?vue&type=style&index=0&id=9a28b2b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a28b2b0",
  null
  
)

export default component.exports